module.exports = __webpack_public_path__ + "assets/img/apple.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/apple.png
// module id = 1932
// module chunks = 0